import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RESTService {
    // Common =======================================================
    private static readonly API_ENDPOINT = '/paymenthub';
    private static readonly JSON_CONTENT_TYPE = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');

    // API end point =======================================================
    public static readonly API_ACCOUNT = "/account";

    // Operations =======================================================
    public static readonly REQUEST_PARAM_CUSTOMER_USERNAME = 'username';
    public static readonly REQUEST_PARAM_TRANSACTION_ID = 'transactionId';
    public static readonly REQUEST_PARAM_ACCOUNT_ID = 'accountId';
    public static readonly REQUEST_PARAM_BILLING_ID = 'billingId';
    public static readonly REQUEST_PARAM_LOCATION_ID = 'locationId';
    public static readonly REQUEST_PARAM_SID = 'sid';
    public static readonly REQUEST_PARAM_RULEID = 'ruleId';

    // Wallet operations =======================================================   
    public static readonly API_WALLET = "/wallet";
    public static readonly API_PAYMENT = "/payment";
    public static readonly API_PAYMENT_CUSTOMPAY = RESTService.API_PAYMENT + "/custom-pay";
    public static readonly API_RECURRING = '/recurring';
    public static readonly API_PAYLOAD = '/payload';

    // payment operations =======================================================   
    public static readonly API_PAYMENT_DEFAULTS = RESTService.API_PAYMENT + '/defaults';
    public static readonly API_PENDING_PAYMENTS = RESTService.API_PAYMENT + '/pending';
    public static readonly API_SCHEDULED_AUTO_PAYMENTS = RESTService.API_RECURRING + '/scheduled-autopays';

    public static readonly API_PAYMENT_PAY = RESTService.API_PAYMENT + '/pay';

    public static readonly API_WALLET_STEP_ONE = RESTService.API_WALLET + '/register';
    public static readonly API_WALLET_STEP_THREE = RESTService.API_WALLET + '/action';
    public static readonly API_WALLET_NICK_NAME = RESTService.API_WALLET + '/nickname';

    constructor(private http: HttpClient) { }

    // REST API =======================================================
    public post(path: string, body: any): Observable<any> {
        return this.http.post<any>(RESTService.API_ENDPOINT + path, body, { headers: RESTService.JSON_CONTENT_TYPE, observe: "response" });
    }

    public post_(path: string, parameters: any, body: any): Observable<any> {
        return this.http.post<any>(RESTService.API_ENDPOINT + path, body, { params: parameters, headers: RESTService.JSON_CONTENT_TYPE, observe: "response" });
    }

    public get(path: string, parameters: any): Observable<any> {
        return this.http.get<any>(RESTService.API_ENDPOINT + path, { params: parameters, headers: RESTService.JSON_CONTENT_TYPE, observe: "response" });
    }

    public put(path: string, parameters: any, body: any): Observable<any> {
        return this.http.put<any>(RESTService.API_ENDPOINT + path, body, { params: parameters, headers: RESTService.JSON_CONTENT_TYPE, observe: "response" });
    }

    public delete(path: string, parameters: any): Observable<any> {
        return this.http.delete<any>(RESTService.API_ENDPOINT + path, { params: parameters, headers: RESTService.JSON_CONTENT_TYPE, observe: "response" });
    }
}
